import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import { useChartTheme } from './useChartTheme';
import './charts.css';

export default function PieChart({
  data,
  colors,
  height = 260,
  title,
  valueFormatter,
  tooltipFormatter,
  innerRadius = 0.55,
  padAngle = 1,
  cornerRadius = 3,
  enableArcLabels = false,
  margin = { top: 12, right: 12, bottom: 24, left: 12 },
}) {
  const palette = React.useMemo(() => colors || ['#2563eb', '#10b981', '#f59e0b', '#334155'], [colors]);
  const formatValue = valueFormatter || ((value) => new Intl.NumberFormat('en-US').format(Number(value) || 0));
  const legendItems = React.useMemo(
    () =>
      (data || []).map((d, idx) => ({
        label: d.label || d.id || d.name || `Slice ${idx + 1}`,
        color: palette[idx % palette.length],
      })),
    [data, palette]
  );
  const theme = useChartTheme();
  return (
    <div className="chart-card">
      {title && <div className="chart-title">{title}</div>}
      <div className="chart-plot" style={{ height }}>
        <ResponsivePie
          data={data || []}
          theme={theme}
          colors={palette}
          margin={margin}
          valueFormat={formatValue}
          innerRadius={innerRadius}
          padAngle={padAngle}
          cornerRadius={cornerRadius}
          enableArcLabels={enableArcLabels}
          arcLinkLabelsSkipAngle={360} // effectively hide link labels to avoid overflow
          arcLinkLabelsTextColor="#334155"
          arcLinkLabelsThickness={0}
          arcLinkLabelsColor={{ from: 'color' }}
          legends={[]}
          
        />
      </div>
      {legendItems.length > 0 && (
        <div className="chart-legend row">
          {legendItems.map((item) => (
            <div key={item.label} className="chart-legend-item">
              <span className="chart-legend-swatch" style={{ backgroundColor: item.color }} />
              <span className="chart-legend-label">{item.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
